import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
    selector: '[selectOnFocus]'
})
export class SelectOnFocusDirective {
    constructor(private el: ElementRef) { }

    @HostListener('focus')
    onFocus() {
        if (this.el.nativeElement && typeof this.el.nativeElement.select === 'function') {
            this.el.nativeElement.select();
        }
    }
}
